<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg291"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs295"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath305"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path303" /></clipPath></defs><g
     id="g297"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g299"><g
         id="g301"
         clip-path="url(#clipPath305)"><g
           id="g307"
           transform="translate(497,474.5)"><path
             d="m 0,0 h -482 c -4.142,0 -7.5,3.358 -7.5,7.5 v 15 c 0,4.142 3.358,7.5 7.5,7.5 H 0 c 4.142,0 7.5,-3.358 7.5,-7.5 V 7.5 C 7.5,3.358 4.142,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0, 30, 1000, 0, 1000, 0;stroke-dashoffset:0;stroke-opacity:1"
             id="path309" /></g><g
           id="g311"
           transform="translate(15,7.5)"><path
             d="m 0,0 h 482 c 4.142,0 7.5,3.358 7.5,7.5 v 15 c 0,4.142 -3.358,7.5 -7.5,7.5 H 0 c -4.142,0 -7.5,-3.358 -7.5,-7.5 V 7.5 C -7.5,3.358 -4.142,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0, 30, 1000, 0, 1000, 0;stroke-dashoffset:0;stroke-opacity:1"
             id="path313" /></g><g
           id="g315"
           transform="translate(15,318.8335)"><path
             d="m 0,0 h 482 c 4.142,0 7.5,3.358 7.5,7.5 v 15 c 0,4.142 -3.358,7.5 -7.5,7.5 H 0 c -4.142,0 -7.5,-3.358 -7.5,-7.5 V 7.5 C -7.5,3.358 -4.142,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0, 30, 1000, 0, 1000, 0;stroke-dashoffset:0;stroke-opacity:1"
             id="path317" /></g><g
           id="g319"
           transform="translate(497,163.1665)"><path
             d="m 0,0 h -482 c -4.142,0 -7.5,3.358 -7.5,7.5 v 15 c 0,4.142 3.358,7.5 7.5,7.5 H 0 c 4.142,0 7.5,-3.358 7.5,-7.5 V 7.5 C 7.5,3.358 4.142,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:0, 30, 1000, 0, 1000, 0;stroke-dashoffset:0;stroke-opacity:1"
             id="path321" /></g><path
           d="M 106.265,348.833 H 31.795 V 444.5 h 74.47 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path323" /><path
           d="m 210.735,348.833 h -74.47 V 444.5 h 74.47 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path325" /><path
           d="m 315.205,348.833 h -74.47 V 444.5 h 74.47 z"
           style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path327" /><g
           id="g329"
           transform="translate(386.4551,414.5005)"><path
             d="M 0,0 V 30 H -30 V 0 c -6.213,0 -11.25,-5.037 -11.25,-11.25 v -54.417 h 52.5 V -11.25 C 11.25,-5.037 6.213,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path331" /></g><g
           id="g333"
           transform="translate(468.9551,414.5005)"><path
             d="M 0,0 V 30 H -30 V 0 c -6.213,0 -11.25,-5.037 -11.25,-11.25 v -54.417 h 52.5 V -11.25 C 11.25,-5.037 6.213,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path335" /></g><g
           id="g337"
           transform="translate(107.061,193.1665)"><path
             d="m 0,0 h -74.47 v 80.667 c 0,8.285 6.716,15 15,15 H -15 c 8.284,0 15,-6.715 15,-15 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path339" /></g><g
           id="g341"
           transform="translate(107.061,273.8335)"><path
             d="m 0,0 c 0,8.285 6.716,15 15,15 h 44.47 c 8.284,0 15,-6.715 15,-15 V -80.667 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path343" /></g><g
           id="g345"
           transform="translate(181.5308,273.8335)"><path
             d="m 0,0 c 0,8.285 6.716,15 15,15 h 44.47 c 8.284,0 15,-6.715 15,-15 V -80.667 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path347" /></g><g
           id="g349"
           transform="translate(350.4702,193.1665)"><path
             d="m 0,0 h -64.469 v 60.666 c 0,8.284 6.716,15 15,15 H -15 c 8.284,0 15,-6.716 15,-15 z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path351" /></g><g
           id="g353"
           transform="translate(350.4702,253.8325)"><path
             d="m 0,0 c 0,8.284 6.716,15 15,15 h 34.47 c 8.284,0 15,-6.716 15,-15 V -60.666 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path355" /></g><g
           id="g357"
           transform="translate(414.9399,253.8325)"><path
             d="m 0,0 c 0,8.284 6.715,15 15,15 h 34.469 c 8.284,0 15,-6.716 15,-15 V -60.666 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path359" /></g><g
           id="g361"
           transform="translate(191.5308,85.3335)"><path
             d="m 0,0 v 32.833 c 0,8.285 -6.716,15 -15,15 h -49.47 c -8.284,0 -15,-6.715 -15,-15 V 0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path363" /></g><g
           id="g365"
           transform="translate(191.5308,85.3335)"><path
             d="m 0,0 h 79.47 v 32.833 c 0,8.285 -6.716,15 -15,15 H 15 c -8.284,0 -15,-6.715 -15,-15"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path367" /></g><g
           id="g369"
           transform="translate(112.0605,118.167)"><path
             d="m 0,0 c 0,8.284 -6.715,15 -15,15 h -49.47 c -8.284,0 -15,-6.716 -15,-15 v -17.833 c 0,-8.285 6.716,-15 15,-15 H 0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path371" /></g><g
           id="g373"
           transform="translate(271.0005,85.3335)"><path
             d="m 0,0 h 64.47 c 8.284,0 15,6.716 15,15 v 17.833 c 0,8.285 -6.716,15 -15,15 H 15 c -8.284,0 -15,-6.715 -15,-15"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path375" /></g><g
           id="g377"
           transform="translate(271.0005,37.5)"><path
             d="m 0,0 h 79.47 v 32.833 c 0,8.285 -6.716,15 -15,15 H 0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path379" /></g><g
           id="g381"
           transform="translate(191.5308,85.3335)"><path
             d="M 0,0 V -47.833 H 79.47"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path383" /></g><g
           id="g385"
           transform="translate(32.5908,70.3335)"><path
             d="M 0,0 V -32.833 H 79.47 V 15 H 15 C 6.716,15 0,8.284 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path387" /></g><g
           id="g389"
           transform="translate(442.7051,103.167)"><path
             d="M 0,0 V 30 H -30 V 0 c -6.213,0 -11.25,-5.037 -11.25,-11.25 v -54.417 h 52.5 V -11.25 C 11.25,-5.037 6.213,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path391" /></g></g></g></g></svg>
</template>
